import ReactJWPlayer from 'react-jw-player'
import optionsJwPlayer from '../../../../modules/options-jwplayer'
import { htmlParser } from '../../../../modules/parse'
import React, { memo } from 'react'
import PropTypes from 'prop-types'
import isEqual from 'lodash/isEqual'
import useTargetsFromPopads from './modules/use-targets-from-popads'
import consoleLogger from '../../../../modules/console-logger'

const VideoPlayer = ({ video, adsTargeting, showAds, imageUrl, autoplay, platformPrefix, ...props }) => {
  const [consoleLog] = consoleLogger('usePopadsTargets')
  let targetings = useTargetsFromPopads(adsTargeting)

  if (targetings) {
    consoleLog('setting AdsTarget to FuncTargets')
    adsTargeting = targetings
  }
  consoleLog('working with ', adsTargeting)

  //JW
  if (video && video.jwId) {
    return (
      <>
        <ReactJWPlayer
          {...optionsJwPlayer({
            jwId: video.jwId,
            targeting: adsTargeting,
            advertising: showAds,
            platformPrefix: platformPrefix,
          })}
          image={imageUrl}
          isAutoPlay={autoplay}
          {...props}
        />
      </>
    )
  }

  //YOUTUBE
  if (video && video.type.localeCompare('youtube') == 0) {
    return <>{video.type === 'youtube' && video.embed && htmlParser(video.embed, { youtubeAutoplay: autoplay })}</>
  }

  //EMBED
  if (video && video.type.localeCompare('embed') == 0) {
    return <>{video.type === 'embed' && video.embed && htmlParser(video.embed)}</>
  }

  //ELSE
  return false
}

VideoPlayer.propTypes = {
  video: PropTypes.shape({
    type: PropTypes.oneOf(['youtube', 'embed']),
    jwId: PropTypes.string,
    url: PropTypes.string,
  }),
  imageUrl: PropTypes.string,
  showAds: PropTypes.bool,
  adsTargeting: PropTypes.object,
  autoplay: PropTypes.bool,
}

VideoPlayer.defaultProps = {
  showAds: true,
}

const areEqual = (prevProps, nextProps) => {
  const equalTargeting = isEqual(prevProps.adsTargeting, nextProps.adsTargeting)
  const equalShowAds = prevProps.showAds === nextProps.showAds
  const equalImageUrl = prevProps.imageUrl === nextProps.imageUrl
  const equalAutoplay = prevProps.autoplay === nextProps.autoplay
  const equalVideoData = isEqual(prevProps.video, nextProps.video)
  return equalAutoplay && equalImageUrl && equalShowAds && equalTargeting && equalVideoData
}

export default memo(VideoPlayer, areEqual)
